module.exports = __webpack_public_path__ + "img/section3_img2.1da55b6b.png";